import { render, staticRenderFns } from "./MoleculeLoadingCard.vue?vue&type=template&id=523f082a&scoped=true&"
import script from "./MoleculeLoadingCard.vue?vue&type=script&lang=js&"
export * from "./MoleculeLoadingCard.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeLoadingCard.vue?vue&type=style&index=0&id=523f082a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523f082a",
  null
  
)

export default component.exports